export default class FaqsSelect {
	constructor() {
		// Listen for click on the document
		document.addEventListener("click", function (event) {
			//Bail if our clicked element doesn't have the class
			if (!event.target.classList.contains("faqs__tabs__select")) {
				return;
			}

			var faqsTabs = document.querySelector("#faqs-tabs");
			var faqsSelect = document.querySelector("#faqs-select");

			faqsTabs.classList.toggle("show");
			faqsSelect.classList.toggle("show");

			event.preventDefault();
		});
	}
}
